import { LocationApiService } from "../../api";

export const provideLocation = () => [LocationApiService];